import * as React from 'react';
import { fairPlayIcon } from '../../../icons';
import { ErrorWrapper } from '../../ErrorWrapper';

export const DeclineError = () => {
  return (
    <ErrorWrapper icon={fairPlayIcon}>
      Запрос на&nbsp;участие в&nbsp;программе «Работаю&nbsp;честно» не&nbsp;может быть зарегистрирован повторно.
      Дождитесь результатов рассмотрения текущего запроса
    </ErrorWrapper>
  );
};
